import React from "react";
import skill1 from "../assets/images/skill/html.png";
import skill2 from "../assets/images/skill/css.png";
import skill3 from "../assets/images/skill/javascript.png";
import skill4 from "../assets/images/skill/react.png";
import skill5 from "../assets/images/skill/tailwind.png";
import skill10 from "../assets/images/skill/bootstrap.png";
import skill6 from "../assets/images/skill/node.png";
import skill7 from "../assets/images/skill/mongo.png";
import skill8 from "../assets/images/skill/firebase.png";
import skill9 from "../assets/images/skill/github.png";

const Skills = () => {
  const skills = [
    {
      logo: `${skill1}`,
      level: "Advance",
      count: 86,
    },
    {
      logo: `${skill2}`,
      level: "Expect",
      count: 90,
    },
    {
      logo: `${skill3}`,
      level: "Expect",
      count: 90,
    },
    {
      logo: `${skill4}`,
      level: "Expect",
      count: 90,
    },
    {
      logo: `${skill5}`,
      level: "Expect",
      count: 90,
    },
    {
      logo: `${skill10}`,
      level: "Expect",
      count: 90,
    },
    {
      logo: `${skill6}`,
      level: "Expect",
      count: 90,
    },
    {
      logo: `${skill7}`,
      level: "Expect",
      count: 90,
    },
    {
      logo: `${skill8}`,
      level: "Expect",
      count: 90,
    },
    {
      logo: `${skill9}`,
      level: "Expect",
      count: 90,
    },
  ];
  return (
    <section id="skills" className="py-10 bg-gray-800 relative">
      <div className="my-8 text-gray-100 text-center">
        <h3 className="text-4xl font-semibold">
          My <span className="text-indigo-600">Skills</span>
        </h3>
        <div className="flex items-center justify-center mt-12 gap-10 flex-wrap">
          {skills?.map((skill, i) => (
            <div
              key={i}
              className="border-4 group border-indigo-600 relative min-w-[8rem] max-w-[12rem] bg-gray-900 p-10 rounded-xl hover:shadow-lg hover:shadow-indigo-500 transform transition duration-500 hover:scale-110"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full">
                <div className="text-6xl w-12 h-12 bg-gray-900 rounded-full flex items-center justify-center group-hover:text-indigo-600">
                  <img src={skill.logo} alt="" className="h-12 mx-auto" />
                  {/* <ion-icon name={skill.logo}></ion-icon> */}
                </div>
              </div>
              {/* <p className="text-xl mt-3">{skill.level}</p> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
